import { IconButton, SxProps } from '@mui/material';
import { FC, ReactNode, useState } from 'react';

import { DropdownHeader } from 'components/shared/CustomDropdown/UserStoryDropdown/styled';

import { ReactComponent as Arrow } from 'assets/icons/arrow-down.svg';

interface TestPlanDropdownHeaderProps {
	isDropped?: boolean;
	children: ReactNode;
	header: ReactNode;
	sx?: SxProps;
}

export const TestPlanDropdownHeader: FC<TestPlanDropdownHeaderProps> = ({
	isDropped = false,
	children,
	header,
	sx,
}) => {
	const [isOpen, setIsOpen] = useState(isDropped);

	const handleDropdownClick = () => {
		setIsOpen((prev) => !prev);
	};

	return (
		<>
			<DropdownHeader
				isStoryOpen={isOpen}
				sx={{
					alignItems: 'center',
					margin: 0,
					padding: isOpen ? '0 0 10px 0' : 0,
					'&>p': {
						width: '100%',
					},

					'& svg': {
						padding: 0,
					},
					...sx,
				}}
			>
				{header}
				<IconButton onClick={handleDropdownClick}>
					<Arrow />
				</IconButton>
			</DropdownHeader>
			{isOpen ? children : null}
		</>
	);
};
